import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { VersionWatcherService } from './version-watcher.service';

/** Feeds every backend response's X-App-Version header to the watcher. */
@Injectable()
export class VersionHeaderInterceptor implements HttpInterceptor {
  private readonly versionWatcher = inject(VersionWatcherService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          this.versionWatcher.notifyBackendVersion(event.headers.get(VersionWatcherService.VERSION_HEADER));
        }
      })
    );
  }
}
